import { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { pvrTheme, inoxTheme } from "./theme/themes";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css"; //icons
import "bootstrap/dist/css/bootstrap.min.css";
import "./custom-style/style.css"; // == global styling
import "./custom-style/queries.css"; // == global styling
import "./custom-style/mobilequeries.css"; // == global styling
import { cinemaChain } from "./constants";
import { HelmetProvider, Helmet } from "react-helmet-async";
import ReactGA from "react-ga";

const React = require("react");

// ==== mobile views pages start rountes ==========
// const Msearch = React.lazy(() =>
//   import("./views/mobile-views/mobile-search/MSearch")
// );
// const MobileMovieDetails = React.lazy(() =>
//   import("./views/mobile-views/mobile-movie-details/MobileMovieDeatils")
// );
// const MobilePersonDetails = React.lazy(() =>
//   import("./views/mobile-views/mobile-person-details/MobilePersonDetails")
// );
// const MobileExperience = React.lazy(() =>
//   import("./views/mobile-views/mobile-experience/MobileExperience")
// );
// const MobileCinemas = React.lazy(() =>
//   import("./views/mobile-views/mobile-cinemas/MobileCinemas")
// );
// const MobilePayment = React.lazy(() =>
//   import("./views/mobile-views/mobile-payment/MobilePayment")
// );
// const MobileGiftCard = React.lazy(() =>
//   import("./views/mobile-views/mobile-gift-cards/MobileGiftCard")
// );
// const MobileProfile = React.lazy(() =>
//   import("./views/mobile-views/mobile-profile/MobileProfile")
// );
// const MobileTicketSummary = React.lazy(() =>
//   import(
//     "./views/mobile-views/mobile-profile/mobile-profile-pages/ProfileBookingDetails"
//   )
// );
// const MobileQRFound = React.lazy(() =>
//   import("./views/mobile-views/mobile-qr-found/MobileQrFound")
// );

// const MobileComingSoon = React.lazy(() =>
//   import("./views/mobile-views/mobile-coming-soon/MobileComingSoon")
// );

// const MobileTrailer = React.lazy(() =>
//   import("./views/mobile-trailer/MobileTrailer")
// );

// // ==== mobile views pages end rountes ============

// const Home = React.lazy(() => import("./views/home/Home"));
// const ShowTime = React.lazy(() => import("./views/show-time/ShowTime"));
// const SeatLayout = React.lazy(() => import("./views/seat-layout/SeatLayout"));
// const GetFood = React.lazy(() => import("./views/get-food/GetFood"));
// const CinemasSession = React.lazy(() =>
//   import("./views/cinemas/cinemaList/CinemasSession")
// );
// const ExperienceDetails = React.lazy(() =>
//   import("./views/cinemas/experiences/ExperienceDetails")
// );
// const Experiences = React.lazy(() =>
//   import("./views/cinemas/experiences/Experiences")
// );
// const PAYMENT = React.lazy(() => import("./views/payment/Payment"));
// const OldQrCODE = React.lazy(() => import("./views/oldQrFood/OldQrFood"));
// const MovieSession = React.lazy(() =>
//   import("./views/movie-sessions/MovieSessions")
// );
// const Cinemas = React.lazy(() => import("./views/cinemas/Cinemas"));
// const Offers = React.lazy(() => import("./views/offers/Offers"));
// const Passport = React.lazy(() => import("./views/passport/Home"));
// const OffersDetail = React.lazy(() => import("./views/offers/OffersDetail"));

// //const Passport = React.lazy(() => import("./views/passport/Pasport"));
// const ComingSoon = React.lazy(() => import("./views/coming-soon/ComingSoon"));
// const Giftcards = React.lazy(() => import("./views/gift-cards/GiftCards"));
// const BulkGiftcards = React.lazy(() => import("./views/gift-cards/BulkPurchage"));
// const KotakPPplus = React.lazy(()=> import('./views/kotak-pp-plus/KotakPPPlus'))
// const MovieOnDemands = React.lazy(() =>
//   import("./views/movie-on-demand/MovieOnDemand")
// );

// // ==== static page toutings =========
// const CoroporateBooking = React.lazy(()=> import('./views/bulk-booking/coroporate-booking/CoroporateBooking'))
// const Advertise = React.lazy(() =>
//   import("./views/static-pages/advertise/Advertise")
// );
// const AboutUs = React.lazy(() =>
//   import("./views/static-pages/about-us/AboutUs")
// );
// const VPristine = React.lazy(() =>
//   import("./views/static-pages/v-pristine/VPristine")
// );
// const FeedbackPage = React.lazy(() =>
//   import("./views/static-pages/feedback/Feedback")
// );
// const Birthday = React.lazy(() =>
//   import("./views/static-pages/birthday-request/Birthday")
// );
// const Oscar = React.lazy(() => import("./views/oscar/Oscar"));
// const Faq = React.lazy(() => import("./views/static-pages/faq/Faq"));
// const News = React.lazy(() => import("./views/static-pages/news/News"));
// const BeyondMovie = React.lazy(() =>
//   import("./views/static-pages/beyond-movies/BeyondMovie")
// );
// const PrivacyPolicy = React.lazy(() =>
//   import("./views/static-pages/privacy-policy/PrivacyPolicy")
// );
// const Termsconditions = React.lazy(() =>
//   import("./views/static-pages/terms-conditions/TermsConditions")
// );
// const Termsuse = React.lazy(() =>
//   import("./views/static-pages/terms-use/Termsuse")
// );
// const DonationTnc = React.lazy(() =>
//   import("./views/static-pages/terms-use/Donation")
// );
// const Careers = React.lazy(() =>
//   import("./views/static-pages/careers-us/Careers")
// );

// const InvestorSections = React.lazy(() =>
//   import("./views/static-pages/investers-section/Investors")
// );

// const MovileLibrary = React.lazy(() =>
//   import("./views/static-pages/movie-library/MovileLibrary")
// );

// const CinemaFormat = React.lazy(() =>
//   import("./views/static-pages/cinema-format/CinemaFormat")
// );

// const Profile = React.lazy(() => import("./views/profile/Profile"));

// const Ticket = React.lazy(() => import("./views/final-ticket/FinalTicket"));
// const PassportTicket = React.lazy(() => import("./views/final-ticket/PassportTicket"));
// const GiftCardTicket = React.lazy(() =>
//   import("./views/final-ticket/GiftCardTicket")
// );
// const FoodTicket = React.lazy(() => import("./views/final-ticket/FoodTicket"));

const EarlyAccess = React.lazy(() => import("./views/early-eccess/EarlyAccess"));
// const Audio = React.lazy(() => import("./views/static-pages/audio/Audio"));

// const SetAlertMovie = React.lazy(()=> import('./views/set-alert-movie/SetAlertMovie'))

// const UnpaidTopaid = React.lazy(()=> import('./views/unpaid-to-paid/UnpaidToPaid'))

const PageNotFound = React.lazy(()=> import('./views/page-not-found/PageNotFound'))



function App() {
  const themeVal = cinemaChain === "PVR" ? "pvrTheme" : "inoxTheme";

  if (typeof localStorage !== 'undefined') {
    // Store the theme value in localStorage
    localStorage.setItem("theme", themeVal);
} else {
    // Handle the case where localStorage is not available
    console.error('localStorage is not available');
} 

const theme = cinemaChain === "PVR" ? pvrTheme : inoxTheme;
const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 575px)').matches;
if (cinemaChain === "PVR") ReactGA.initialize("G-CPXWTKDXV8");
  else ReactGA.initialize("G-FYEYSCFLNJ");

  const loading = (
    <div className="pt-3 d-flex justify-content-center align-items-center" style={{ height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div>
        <i className="pi pi-spin pi-spinner" style={{'fontSize': '5em', color: cinemaChain === "PVR" ? "#FFCB05" :'#234B9E'}}></i>
        </div>
    </div>
  );

  // if (!localStorage.getItem("lat")) {
  //   localStorage.setItem("lat", "0.000");
  //   localStorage.setItem("long", "0.000");
  // }

  // Check if localStorage is available
if (typeof localStorage !== 'undefined') {
  // Check if the 'lat' key is not already set
  if (!localStorage.getItem("lat")) {
      // Set the 'lat' and 'long' keys to default values
      localStorage.setItem("lat", "0.000");
      localStorage.setItem("long", "0.000");
  }
} else {
  // Handle the case where localStorage is not available
  console.error('localStorage is not available');
}
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet>
          <title>{cinemaChain === "PVR" ? "PVR Cinemas" : "INOX Movies"}</title>
          <link
            rel="icon"
            href={cinemaChain === "PVR" ? "/pvr.ico" : "/inox.ico"}
          />
          <meta name="description" content="PVR INOX" />
        </Helmet>
        <ThemeProvider theme={theme}>
          <Suspense fallback={loading}>
            <Router>
              <Routes>
                
                <Route path="/" name="Home" element={<PageNotFound />} />
                
                <Route
                  path=":movieId"
                  name="Early Access"
                  element={<EarlyAccess />}
                />
                 
                <Route path="*" name='Page not found' element={<PageNotFound/>} />
              </Routes>
            </Router>
          </Suspense>
        </ThemeProvider>
      </HelmetProvider>
    </React.Fragment>
  );
}

export default App;
